<template>
  <div class="ws-state-switch-tab">
    <div
      class="ws-state-switch-tab__item"
      v-for="(item,itemIndex) in items"
      :key="itemIndex"
      :class="{active:$_getActive(item.value)&&!_disabled, 'is-disabled': _disabled}"
      @click="$_onClick(item)"
    >
      {{item.text}}
    </div>
  </div>
</template>
<script>
export default {
  name: "WsStateSwitchTab",
  props: {
    value: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    defaultValue: {
      type: [String, Number],
      default: null,
    },
    requiredFieldValue: {},
    requiredFieldState: {},
  },
  computed: {
    _disabled() {
      if (
        this.requiredFieldValue === undefined ||
        this.requiredFieldState === undefined
      ) return false;
      if (
        Array.isArray(this.requiredFieldValue) &&
        Array.isArray(this.requiredFieldState)
      ) return !this.$_isEqualArray(this.requiredFieldValue, this.requiredFieldState);
      else if (
        (Array.isArray(this.requiredFieldValue) &&
        !Array.isArray(this.requiredFieldState)) ||
        (!Array.isArray(this.requiredFieldValue) &&
        Array.isArray(this.requiredFieldState))
      ) return true;
      else if (
        typeof this.requiredFieldValue === 'object' &&
        typeof this.requiredFieldState === 'object'
      ) return !this.$_isEqualObject(this.requiredFieldValue, this.requiredFieldState);
      else if (
        (typeof this.requiredFieldValue !== 'object' &&
        typeof this.requiredFieldState === 'object') ||
        (typeof this.requiredFieldValue === 'object' &&
        typeof this.requiredFieldState !== 'object')
      ) return true;
      else return !this.$_isEqualVal(this.requiredFieldValue, this.requiredFieldState);
    },
  },
  methods: {
    $_getActive(value) {
      if (this.value === value) {
        return true;
      } else {
        return false;
      }
    },
    $_onClick(item) {
      if (this._disabled) return;
      this.$emit("input", item.value);
    },
    $_getDefaultValue() {
      if (this.defaultValue && !this.value) {
        this.$emit("input", this.defaultValue);
      }
    },
    $_isEqualArray(requiredArr, testedArr) {
      if (requiredArr.length !== testedArr.length) return false;
      const compareFunction = (a, b) => {
        if (typeof a === 'number' && typeof b === 'number') return a - b;
        if (typeof a === 'string' && typeof b === 'string') return a.localeCompare(b);
        return typeof a === 'number' ? -1 : 1;
      };
      const sortedArr1 = [...requiredArr].sort(compareFunction);
      const sortedArr2 = [...testedArr].sort(compareFunction);
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) return false;
      }
      return true;
    },
    $_isEqualObject(requiredObj, testedObj) {
      if (requiredObj === null && testedObj === null) return true;
      else if (requiredObj === null || testedObj === null) return false;
      const requiredKeys = Object.keys(requiredObj);
      const testedKeys = Object.keys(testedObj);
      if (requiredKeys.length !== testedKeys.length) return false;
      for (let key of requiredKeys) {
        if (!testedKeys.includes(key) || !this.$_isEqualObject(requiredObj[key], testedObj[key])) return false;
      }
      return true;
    },
    $_isEqualVal(requiredVal, testedVal) {
      if (typeof requiredVal !== typeof testedVal) return false;
      return requiredVal === testedVal;
    }
  },
  mounted() {
    this.$_getDefaultValue();
  },
};
</script>
<style lang="scss">
@import "@/__vue2cmsstonevuetify/assets/scss/ws-state-switch-tab";
</style>